import { NotificationId as Api } from '@tableau/api-internal-contract-js';
import { NotificationId as PL } from '../../gen-src/preslayer/Events';
import { PresLayerToSharedApiConverter } from './PresLayerToSharedApiConverter';

// TODO TFSID 1106239 simplify api-platform mapping registration system
// tslint:disable-next-line:no-any
export type ConversionFn = (presModel: any) => any;

/**
 * Simple wrapper which holds a mapping to go from a pres-layer event to an API event
 */
export class EventMappingRegistration {
  public get presLayerId(): PL {
    return this._presLayerId;
  }

  public get apiId(): Api {
    return this._apiId;
  }

  public get converter(): ConversionFn {
    return this._converter;
  }

  public constructor(private _presLayerId: PL, private _apiId: Api, private _converter: ConversionFn) {}
}

/**
 * Simple type which has keys of PL event ids to EventMappingRegistrations
 */
export type EventMappingRegistry = { [key: string]: EventMappingRegistration };

export class SharedEventMappingRegistryFactory {
  /**
   * Creates and populates a new EventMappingRegistry
   *
   * @returns {EventMappingRegistry}
   */
  public static createEventMappingRegistry(): EventMappingRegistry {
    const registry: EventMappingRegistry = {};
    registry[PL.SelectionChanged] = new EventMappingRegistration(
      PL.SelectionChanged,
      Api.SelectedMarksChanged,
      PresLayerToSharedApiConverter.convertVisualId,
    );

    registry[PL.ParameterChanged] = new EventMappingRegistration(
      PL.ParameterChanged,
      Api.ParameterChanged,
      PresLayerToSharedApiConverter.convertFieldCaptionPair,
    );

    registry[PL.FilterChanged] = new EventMappingRegistration(
      PL.FilterChanged,
      Api.FilterChanged,
      PresLayerToSharedApiConverter.convertFilterEvent,
    );

    registry[PL.SummaryDataChanged] = new EventMappingRegistration(
      PL.SummaryDataChanged,
      Api.SummaryDataChanged,
      PresLayerToSharedApiConverter.convertSummaryDataEvent,
    );

    return registry;
  }
}
